import {call, select, put, takeEvery, takeLatest} from 'redux-saga/effects'
import Api from './CategorySubscriptionApi'
import * as actions from "./actions";
import * as errorActions from "./../error/actions";
import * as userSelectors from "../user/selectors";

export function* getSubscriptions() {
  try {
    const isLoggedin = yield select (userSelectors.isLoggedIn);

    //set _subscriptions_ loading
    if(isLoggedin) {
      const subscriptions = yield call(Api.getCategorySubscriptions);
      yield put(actions.Generator.setSubscriptions(subscriptions.data));
    }
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}

function* toggleSubscription(action) {
  try {
    yield put(actions.Generator.setSubscriptionLoading(action.categoryId, true));
    const subscriptions = yield call(Api.toggleSubscription, action.categoryId);
    yield put(actions.Generator.setSubscriptions(subscriptions.data));
    yield put(actions.Generator.setSubscriptionLoading(action.categoryId, false));
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
    yield put(actions.Generator.setSubscriptionLoading(action.categoryId, false));
  }
}

function* subscriptionSaga() {
  yield takeEvery(actions.SAGA_CATEGORY_SUBSCRIPTIONS_REQUESTED, getSubscriptions);
  yield takeLatest(actions.SAGA_TOGGLE_SUBSCRIPTION, toggleSubscription);
}

export default subscriptionSaga;